import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './ScrollAnimations.css';

// One switch removes the section entrance effects without changing any layouts.
const ENABLE_SCROLL_ANIMATIONS = true;
const REVEAL_INSET = 64;

export default function ScrollAnimations() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!ENABLE_SCROLL_ANIMATIONS || typeof IntersectionObserver === 'undefined' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const sections = [...document.querySelectorAll('.home-page main > section, .site-footer, .content-page > .MuiGrid-container, .content-page > .MuiBox-root, .content-page > .MuiContainer-root')];
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('scroll-reveal-pending');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: `0px 0px -${REVEAL_INSET}px 0px`, threshold: 0 });
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (!rect.height || (rect.top < window.innerHeight - REVEAL_INSET && rect.bottom > 0)) return;
      section.classList.add('scroll-reveal', 'scroll-reveal-pending');
      observer.observe(section);
    });
    return () => {
      observer.disconnect();
      sections.forEach(section => section.classList.remove('scroll-reveal', 'scroll-reveal-pending'));
    };
  }, [pathname]);
  return null;
}
